/* WEIRD CASTLE — the eggs + homepage life (v11). Runs on every page; each egg
   guards on its element. Global eggs (tab title, Konami parade, boops) run
   everywhere. Config via window.WCEGGS = { pigeon }. */
(function () {
  var CFG = window.WCEGGS || {};
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (id) { return document.getElementById(id); };

  // ---- sfx ----
  var AC = null;
  function boop(f, dur, type) {
    try {
      AC = AC || new (window.AudioContext || window.webkitAudioContext)();
      if (AC.state === "suspended") { AC.resume(); return; }
      var o = AC.createOscillator(), g = AC.createGain();
      o.type = type || "square"; o.frequency.value = f;
      g.gain.setValueAtTime(0.05, AC.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001, AC.currentTime + (dur || 0.12));
      o.connect(g); g.connect(AC.destination); o.start(); o.stop(AC.currentTime + (dur || 0.12));
    } catch (e) {}
  }

  // ---- toast ----
  var toastT = null;
  function toast(t) {
    var el = $("wc-toast");
    if (!el) {
      el = document.createElement("div"); el.id = "wc-toast"; el.setAttribute("role", "status");
      el.style.cssText = "position:fixed;bottom:26px;left:50%;transform:translate(-50%,14px);z-index:99999;background:#16110d;color:#fbf4e4;font-family:ui-monospace,Menlo,monospace;font-size:12.5px;padding:10px 16px;border-radius:10px;border:2.5px solid #fbf4e4;opacity:0;pointer-events:none;transition:opacity .25s,transform .25s;max-width:82vw;text-align:center;";
      document.body.appendChild(el);
    }
    el.textContent = t;
    el.style.opacity = "1"; el.style.transform = "translate(-50%,0)";
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.style.opacity = "0"; el.style.transform = "translate(-50%,14px)"; }, 2200);
  }

  // ---- hero diorama: scroll + pointer parallax ----
  var dio = $("wc-diorama");
  if (dio && !reduced) {
    var layers = dio.querySelectorAll(".dio[data-depth]");
    var mx = 0, my = 0, ticking = false;
    function apply() {
      ticking = false;
      var sy = window.scrollY;
      layers.forEach(function (l) {
        var d = parseFloat(l.getAttribute("data-depth")) || 0;
        var py = sy * d * 0.45;
        var ox = mx * d * 26, oy = my * d * 14;
        var base = l.classList.contains("dio-castle") || l.classList.contains("dio-crowd") ? "translateX(-50%) " : "";
        // drifting clouds animate via CSS `animation` on transform-less props? no —
        // they animate transform, so skip parallax for them (they carry `animation`).
        if (l.style.animationName || getComputedStyle(l).animationName !== "none") return;
        l.style.transform = base + "translate(" + ox + "px," + (py + oy) + "px)";
      });
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    window.addEventListener("scroll", req, { passive: true });
    dio.addEventListener("pointermove", function (e) {
      var r = dio.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - 0.5;
      my = (e.clientY - r.top) / r.height - 0.5;
      req();
    });
  }

  // ---- elevator rail: reliable click + active state ----
  var liftLinks = document.querySelectorAll(".lift a[data-target]");
  if (liftLinks.length) {
    liftLinks.forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        var t = document.getElementById(b.getAttribute("data-target"));
        if (t) { t.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" }); boop(500, 0.08); }
      });
    });
    if ("IntersectionObserver" in window) {
      var btns = {};
      liftLinks.forEach(function (b) { btns[b.getAttribute("data-floor")] = b; });
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) {
            Object.keys(btns).forEach(function (k) { btns[k].classList.remove("on"); });
            var b = btns[en.target.getAttribute("data-floor")]; if (b) b.classList.add("on");
          }
        });
      }, { rootMargin: "-40% 0px -40% 0px" });
      document.querySelectorAll("div[data-floor]").forEach(function (f) { io.observe(f); });
    }
  }

  // ---- machine room: countdown to next 13:00 UTC invention ----
  var cdEls = document.querySelectorAll("#wc-countdown, [data-wc-countdown]");
  if (cdEls.length) {
    var tickCd = function () {
      var now = new Date();
      var next = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 13, 0, 0));
      if (next <= now) next.setUTCDate(next.getUTCDate() + 1);
      var s = Math.floor((next - now) / 1000);
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var t = String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0") + ":" + String(sec).padStart(2, "0");
      cdEls.forEach(function (el) { el.textContent = t; });
    };
    tickCd(); setInterval(tickCd, 1000);
  }

  // ---- card tilt ----
  if (!reduced) document.querySelectorAll(".tilt").forEach(function (card) {
    var wrap = card.parentElement;
    wrap.addEventListener("mousemove", function (e) {
      var r = wrap.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = "rotateY(" + x * 14 + "deg) rotateX(" + (-y * 12) + "deg) translateZ(8px)";
    });
    wrap.addEventListener("mouseleave", function () { card.style.transform = "none"; });
  });

  // ---- random fluid blinks (Web Animations; irregular, occasionally double) ----
  var blinkEyes = document.querySelectorAll(".blinker .eye");
  if (blinkEyes.length && !reduced && "animate" in Element.prototype) {
    blinkEyes.forEach(function (eye) {
      (function schedule() {
        var wait = 1400 + Math.random() * 6200;
        setTimeout(function () {
          var dbl = Math.random() < 0.28;
          var blink = function () {
            return eye.animate(
              [{ transform: "scaleY(1)" }, { transform: "scaleY(0.06)", offset: 0.45 }, { transform: "scaleY(0.06)", offset: 0.6 }, { transform: "scaleY(1)" }],
              { duration: 150 + Math.random() * 110, easing: "ease-in-out" });
          };
          var a = blink();
          if (dbl) a.onfinish = function () { setTimeout(blink, 90); };
          schedule();
        }, wait);
      })();
    });
  }

  // ---- eyes follow cursor ----
  var pupils = document.querySelectorAll(".pupil");
  if (pupils.length) document.addEventListener("mousemove", function (e) {
    pupils.forEach(function (p) {
      var r = p.parentElement.getBoundingClientRect();
      var a = Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2));
      var d = Math.min(7, Math.hypot(e.clientX - r.left, e.clientY - r.top) / 24);
      p.style.transform = "translate(" + Math.cos(a) * d + "px," + Math.sin(a) * d + "px)";
    });
  });

  // ---- EGG: triple-click logo -> it files a complaint ----
  var logo = $("wc-logo");
  var wcOnHome = location.pathname === "/" || location.pathname === "";
  if (logo && wcOnHome) {
    var logoClicks = 0, logoTimer = null;
    logo.addEventListener("click", function (e) {
      e.preventDefault();
      logoClicks++; boop(500 + logoClicks * 100, 0.08);
      clearTimeout(logoTimer); logoTimer = setTimeout(function () { logoClicks = 0; }, 800);
      if (logoClicks >= 3) {
        logoClicks = 0;
        if (logo.animate) logo.animate(
          [{ transform: "rotate(0)" }, { transform: "rotate(360deg) scale(1.08)" }, { transform: "rotate(360deg) scale(1)" }],
          { duration: 650, easing: "cubic-bezier(.2,.9,.3,1.3)" });
        var LN = ["THE LOGO IS NOT FOR SALE. EVERYTHING ELSE IS.", "STOP SPINNING THE SIGN. IT'S LOAD-BEARING.", "HR HAS BEEN NOTIFIED. WE ARE HR.", "IT LIKED THAT. DON'T DO IT AGAIN."];
        toast(LN[Math.floor(Math.random() * LN.length)]); boop(880, 0.2, "triangle");
      }
    });
  }

  // ---- EGG: ticker complaint ----
  var ticker = $("wc-ticker");
  if (ticker) {
    var tl = ticker.querySelector(".tickerline"), tickerMad = 0;
    ticker.addEventListener("click", function () {
      tickerMad++;
      tl.style.animationPlayState = tl.style.animationPlayState === "paused" ? "running" : "paused";
      var halted = tl.style.animationPlayState === "paused";
      toast(halted ? (tickerMad < 3 ? "TRADING HALTED. THE SEC HAS BEEN NOTIFIED." : "THE MARKET DOES NOT LIKE BEING TOUCHED.") : "TRADING RESUMED. NOTHING WAS LEARNED.");
      boop(180, 0.15, "sawtooth");
    });
  }

  // ---- EGG: money button dodges once ----
  var mb = $("wc-moneybtn");
  if (mb) {
    var dodged = false;
    mb.addEventListener("mouseenter", function () {
      if (dodged) return; dodged = true;
      mb.style.transform = "translate(80px, -6px) rotate(3deg)";
      setTimeout(function () { mb.style.transform = ""; toast("FINE. TAKE IT."); }, 500);
    });
  }

  // ---- EGG: draggable DO-NOT-MOVE sticker ----
  var ds = $("wc-dragstick"), us = $("wc-understick"), bug = $("wc-bug");
  if (ds && us && bug) {
    var sec = document.querySelector("#drops section");
    ds.style.right = "6%"; ds.style.top = "38px";
    us.style.right = "5%"; us.style.top = "58px";
    bug.style.right = "10%"; bug.style.top = "70px";
    var drag = null;
    ds.addEventListener("pointerdown", function (e) {
      var r = ds.getBoundingClientRect(), sr = sec.getBoundingClientRect();
      drag = { dx: e.clientX - r.left, dy: e.clientY - r.top, sr: sr };
      ds.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    ds.addEventListener("pointermove", function (e) {
      if (!drag) return;
      ds.style.right = "auto"; ds.style.left = (e.clientX - drag.sr.left - drag.dx) + "px";
      ds.style.top = (e.clientY - drag.sr.top - drag.dy) + "px";
      if (us.style.opacity !== "1") {
        us.style.opacity = "1"; bug.classList.add("go");
        toast("YOU WEREN'T SUPPOSED TO MOVE THAT."); boop(240, 0.2);
      }
    });
    ds.addEventListener("pointerup", function () { drag = null; });
  }

  // ---- EGG: RIP ghost ----
  var rip = $("wc-ripcard");
  if (rip) rip.addEventListener("click", function (e) {
    var g = document.createElement("div");
    g.textContent = "👻"; g.style.cssText = "position:absolute;left:" + (e.offsetX || 60) + "px;top:20px;font-size:34px;animation:wc-ghostup 1.6s ease-out forwards;pointer-events:none;";
    this.appendChild(g); setTimeout(function () { g.remove(); }, 1700);
    toast("IT FORGIVES YOU. IT'S LYING."); boop(320, 0.3, "sine");
  });

  // ---- EGG: patch door ----
  var pd = $("wc-patchdoor");
  if (pd) pd.addEventListener("click", function () {
    toast("LOCKED. THE PATCHES AREN'T READY. THEY KNOW WHY."); boop(150, 0.2, "sawtooth");
  });

  // ---- founders salute ----
  document.querySelectorAll(".salute").forEach(function (im) {
    im.addEventListener("click", function () {
      toast("🫡 SALUTE REGISTERED. THE HAT ACKNOWLEDGES YOU."); boop(540, 0.15, "triangle");
    });
  });

  // ---- machine: reject-pile simulator (visual card + demand link) ----
  var mo = $("wc-machineout"), mgo = $("wc-machinego");
  if (mo && mgo) {
    var ADJ = ["EMOTIONAL SUPPORT", "PRE-DISASTER", "CHRONICALLY ONLINE", "GOVERNMENT ISSUE", "LIGHTLY HAUNTED", "TAX SEASON", "WITNESS PROTECTION", "PARTICIPATION", "LOAD-BEARING", "DECOMMISSIONED"];
    var NOUN = ["MUG", "TRUCKER HAT", "COMPRESSION SOCKS", "HOODIE", "STICKER PACK", "GARDEN GNOME", "DESK FLAG", "ONESIE", "OVEN MITT", "MOUSEPAD"];
    var ICON = { MUG: "☕", "TRUCKER HAT": "🧢", "COMPRESSION SOCKS": "🧦", HOODIE: "🥷", "STICKER PACK": "🏷️", "GARDEN GNOME": "🪆", "DESK FLAG": "🚩", ONESIE: "👶", "OVEN MITT": "🧤", MOUSEPAD: "🖱️" };
    var WHY = ["TOO REAL.", "LEGAL SAID NO.", "THE HUMAN FLINCHED.", "IT SCARED THE INTERN.", "WOULD ACTUALLY SELL. SUSPICIOUS."];
    mgo.addEventListener("click", function () {
      var noun = NOUN[Math.floor(Math.random() * NOUN.length)];
      var name = ADJ[Math.floor(Math.random() * ADJ.length)] + " " + noun;
      var price = "$" + (Math.floor(Math.random() * 42) + 8) + ".99";
      var why = WHY[Math.floor(Math.random() * WHY.length)];
      mo.innerHTML =
        '<div style="background:#10181c;border:3px dashed #39515b;border-radius:10px;padding:10px;text-align:left;position:relative;">' +
        '<div style="width:84px;height:84px;margin:0 auto;border-radius:8px;background:repeating-linear-gradient(45deg,#182228 0 10px,#131b20 10px 20px);display:flex;align-items:center;justify-content:center;font-size:38px;filter:grayscale(1) brightness(1.6);">' + (ICON[noun] || "❓") + "</div>" +
        '<div style="position:absolute;top:14px;right:10px;transform:rotate(12deg);border:2.5px solid #e8352a;color:#e8352a;border-radius:6px;padding:1px 7px;font-family:\'Arial Black\',Arial,sans-serif;font-size:10px;">REJECTED</div>' +
        '<div class="mono" style="font-size:11px;color:#c9dbe2;margin-top:8px;line-height:1.7;">' + name + " — " + price + '<br><span style="color:#7d949c;">CAUSE: ' + why + "</span></div>" +
        '<a href="/pages/contact?demand=' + encodeURIComponent(name) + '" style="display:inline-block;margin-top:8px;color:#ffc42e;font-weight:700;text-decoration:none;font-family:ui-monospace,monospace;font-size:11px;">DEMAND IT ANYWAY →</a>' +
        "</div>";
      boop(420 + Math.random() * 300, 0.15);
    });
  }

  // ---- basement: REP slides out from behind the door, then speaks ----
  var repw = $("wc-repwrap");
  if (repw && "IntersectionObserver" in window) {
    new IntersectionObserver(function (es, io) {
      es.forEach(function (en) {
        if (en.isIntersecting) { setTimeout(function () { repw.classList.add("arrived"); boop(210, 0.25, "sine"); }, 250); io.disconnect(); }
      });
    }, { threshold: 0.4 }).observe(repw);
  } else if (repw) repw.classList.add("arrived");

  // ---- basement: flashlight follows the cursor through the void ----
  var veil = $("wc-void-veil");
  if (veil) {
    var voidEl = veil.parentElement;
    if (window.matchMedia("(pointer: fine)").matches) {
      voidEl.addEventListener("pointermove", function (e) {
        var r = voidEl.getBoundingClientRect();
        veil.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
        veil.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100) + "%");
      });
    } else { veil.style.setProperty("--mx", "50%"); veil.style.setProperty("--my", "58%"); }
  }

  // ---- homepage TV teaser: three mini CRTs come alive in view ----
  var teaser = $("wc-tv-teaser");
  if (teaser) {
    fetch(teaser.getAttribute("data-playlist")).then(function (r) { return r.json(); }).then(function (j) {
      var tapes = (j.tapes || []).slice();
      var day = Math.floor(Date.now() / 86400000);
      var start = day % Math.max(1, tapes.length - 3);
      var minis = teaser.querySelectorAll(".crt-mini");
      minis.forEach(function (m, i) {
        var t = tapes[(start + i) % tapes.length];
        if (!t) return;
        var pw = t.poster ? t.poster + (t.poster.indexOf("?") > -1 ? "&" : "?") + "width=360" : "";
        m.style.cssText += "position:relative;border:3px solid #000;border-radius:12px;overflow:hidden;background:#000;box-shadow:0 12px 24px rgba(0,0,0,.5);cursor:pointer;";
        m.innerHTML = '<video muted loop playsinline preload="none" ' + (pw ? 'poster="' + pw + '"' : "") + ' style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;"></video>' +
          '<div style="position:absolute;inset:0;background:repeating-linear-gradient(0deg,rgba(0,0,0,.18) 0 1px,transparent 1px 3px);pointer-events:none;"></div>' +
          '<span style="position:absolute;top:6px;left:8px;font-family:ui-monospace,monospace;font-size:10px;color:#7CFC90;text-shadow:0 0 5px rgba(124,252,144,.8);">CH-0' + (i + 3) + "</span>";
        var v = m.querySelector("video");
        m.addEventListener("click", function () { location.href = "/pages/wc-tv"; });
        if ("IntersectionObserver" in window && !reduced) {
          new IntersectionObserver(function (es) {
            es.forEach(function (en) {
              if (en.isIntersecting) { if (!v.src) v.src = t.url; v.play().catch(function () {}); }
              else v.pause();
            });
          }, { threshold: 0.35 }).observe(m);
        }
      });
    }).catch(function () {});
  }

  // ---- contact page: honor ?demand= from the reject pile ----
  try {
    var demand = new URLSearchParams(location.search).get("demand");
    if (demand) {
      var body = document.querySelector('textarea[name="contact[body]"], textarea[name="contact[Message]"], form[action*="/contact"] textarea');
      if (body && !body.value) {
        body.value = "I demand the " + demand + ". I saw it in the reject pile. The machine made it for a reason. I have money.";
        toast("THE FORM HAS BEEN BRIEFED.");
      }
    }
  } catch (e) {}

  // ---- EGG: footer DO-NOT-PULL crawlspace ----
  var fi = $("wc-footer-inner"), lt = $("wc-liftTab");
  if (fi && lt) lt.addEventListener("click", function () {
    fi.classList.toggle("lifted");
    if (fi.classList.contains("lifted")) { toast("WE TOLD YOU NOT TO PULL."); boop(110, 0.4, "sawtooth"); }
  });

  // ---- EGG: visitor counter ----
  var counterEl = $("wc-counter");
  if (counterEl) {
    var day = Math.floor(Date.now() / 86400000);
    var bumps = 0;
    try { bumps = parseInt(localStorage.getItem("wc-counted") || "0", 10) || 0; } catch (e) {}
    var count = 4213 + (day % 1000) * 3 + bumps;
    var renderCounter = function () {
      var s = String(count).padStart(6, "0");
      counterEl.innerHTML = s.split("").map(function (d) {
        return '<span style="background:#000;color:#7CFC90;border:2px solid #2a2434;border-radius:4px;padding:3px 6px;margin-right:2px;display:inline-block;">' + d + "</span>";
      }).join("");
    };
    renderCounter();
    counterEl.addEventListener("click", function () {
      count++; bumps++;
      try { localStorage.setItem("wc-counted", String(bumps)); } catch (e) {}
      renderCounter(); toast("THAT WAS YOU. WE COUNTED."); boop(760, 0.1, "triangle");
    });
  }

  // ---- EGG (global): tab-blur title ----
  var realTitle = document.title;
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) { realTitle = document.title; document.title = "COME BACK."; }
    else document.title = realTitle;
  });

  // ---- EGG (global): konami market crash ----
  (function () {
    var seq = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65], si = 0;
    document.addEventListener("keydown", function (e) {
      si = (e.keyCode === seq[si]) ? si + 1 : 0;
      if (si === seq.length) {
        si = 0;
        var tl2 = document.querySelector("#wc-ticker .tickerline");
        toast("THE MARKET JUST CRASHED. THANKS.");
        boop(160, 0.5, "sawtooth");
        if (tl2) {
          var oldDur = tl2.style.getPropertyValue("--td");
          tl2.style.setProperty("--td", "3s");
          tl2.style.filter = "hue-rotate(140deg) saturate(2)";
          setTimeout(function () {
            tl2.style.setProperty("--td", oldDur || "40s");
            tl2.style.filter = "";
            toast("BAILOUT RECEIVED. BUSINESS AS USUAL.");
            boop(660, 0.2, "triangle");
          }, 6000);
        }
      }
    });
  })();

  // ---- hero crowd ----
  var hp = $("wc-heropigeon");
  if (hp) hp.addEventListener("click", function () {
    toast("THE STAFF WAVES BACK. DON'T READ INTO IT."); boop(980, 0.1, "triangle");
  });

  // ---- voice-note eggs (secondary pages) ----
  document.querySelectorAll("[data-wc-voice-egg]").forEach(function (el) {
    el.style.cursor = "pointer";
    el.addEventListener("click", function () {
      toast(el.getAttribute("data-wc-voice-egg")); boop(430, 0.14, "triangle");
    });
  });


  // ================= v13 =================

  // ---- signal beacon (engine /api/signal counts these; losing one is fine) ----
  function signal(e) {
    try { navigator.sendBeacon("https://api.weirdcastle.com/api/signal", JSON.stringify({ e: e })); } catch (x) {}
  }

  // ---- the elevator actually runs: car rides the rail with your scroll ----
  var car = $("wc-lift-car");
  if (car) {
    var rail = car.parentElement;
    var carT = null;
    function parkCar() {
      var btns = rail.querySelectorAll("a[data-floor]");
      if (!btns.length) return;
      var doc = document.documentElement;
      var f = Math.min(1, Math.max(0, window.scrollY / (doc.scrollHeight - window.innerHeight)));
      var first = btns[0], last = btns[btns.length - 1];
      var top = first.offsetTop + f * (last.offsetTop - first.offsetTop);
      car.style.top = top + "px";
    }
    window.addEventListener("scroll", function () { if (!carT) carT = requestAnimationFrame(function () { carT = null; parkCar(); }); }, { passive: true });
    parkCar();
    var CARLINES = ["THE OPERATOR IS ON BREAK. FOREVER.", "NO SMOKING IN THE CAR. HE SMOKES ANYWAY.", "MAXIMUM OCCUPANCY: ZERO. YOU ARE WATCHING AN EMPTY ELEVATOR.", "HE DOES NOT STOP AT FLOOR 13. THERE IS NO FLOOR 13. STOP ASKING."];
    var carLine = 0;
    car.addEventListener("click", function () { toast(CARLINES[carLine++ % CARLINES.length]); boop(620, 0.1, "triangle"); });
  }

  // ---- founders hats: headline A/B (sticky per visitor) + click signals ----
  var abEls = document.querySelectorAll(".hat-h[data-ab-a]");
  if (abEls.length) {
    var v;
    try { v = localStorage.getItem("wc-ab-hats"); } catch (e) {}
    if (v !== "a" && v !== "b") {
      v = Math.random() < 0.5 ? "a" : "b";
      try { localStorage.setItem("wc-ab-hats", v); } catch (e) {}
    }
    abEls.forEach(function (h) { h.textContent = h.getAttribute("data-ab-" + v) || h.textContent; });
    signal("hat_view_" + v);
    document.querySelectorAll(".wc-hat-cta").forEach(function (a) {
      a.addEventListener("click", function () { signal("hat" + a.getAttribute("data-hat") + "_click_" + v); });
    });
  }

  // ---- count reject-pile demand clicks ----
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest('a[href*="demand="]');
    if (t) signal("demand_click");
  });

  // ---- EGG (global): a cockroach lives under one random product card ----
  var cards = document.querySelectorAll(".wc-card");
  if (cards.length && !reduced) {
    var lucky = cards[Math.floor(Math.random() * cards.length)];
    lucky.style.position = "relative";
    lucky.addEventListener("mouseenter", function once() {
      lucky.removeEventListener("mouseenter", once);
      var r = document.createElement("div");
      r.textContent = "🪳";
      r.style.cssText = "position:absolute;left:8px;bottom:6px;font-size:15px;pointer-events:none;z-index:3;transition:transform 1.1s cubic-bezier(.2,.9,.4,1),opacity .2s 1s;";
      lucky.appendChild(r);
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        r.style.transform = "translate(" + (120 + Math.random() * 120) + "px,-30px) rotate(40deg)"; r.style.opacity = "0";
      }); });
      setTimeout(function () { r.remove(); }, 1600);
      toast("HE LIVES THERE. DON'T MAKE IT WEIRD.");
    });
  }

  // ---- PRINT MARGINALIA: the machine stamps a few manifest cards each day ----
  var stampCards = document.querySelectorAll(".card-product, .wc-card");
  if (stampCards.length >= 3) {
    var STAMPS = [["INSPECTED \u00b7 \u21167", ""], ["APPROVED 7:00 AM", "green"], ["ALLEGEDLY NEW", "blue"], ["THE HUMAN HESITATED", ""], ["PRINTED ANYWAY", "blue"], ["MISPRICED. FINAL.", "green"]];
    var stampDay = Math.floor(Date.now() / 86400000);
    var used = [];
    for (var sk = 0; sk < Math.min(3, Math.floor(stampCards.length / 4) + 1); sk++) {
      var sidx = (stampDay * 7 + sk * 13) % stampCards.length;
      if (used.indexOf(sidx) > -1) continue;
      used.push(sidx);
      var sc = stampCards[sidx];
      if (getComputedStyle(sc).position === "static") sc.style.position = "relative";
      var st = document.createElement("span");
      var spick = STAMPS[(stampDay + sk * 5) % STAMPS.length];
      st.className = "wcp-stamp wcp-rubber " + spick[1];
      st.textContent = spick[0];
      sc.appendChild(st);
    }
  }

  // ---- MOTION: panels settle onto the desk as they enter view ----
  var revealSel = ".wcp-panel, .wcp-coupon, .door, .hats, .machine-shell, .grid-item, .shelf, .report, .wcp-secthead, .booth";
  var revealEls = document.querySelectorAll(revealSel);
  if (!reduced && "IntersectionObserver" in window && revealEls.length) {
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("wcp-in"); rio.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -30px 0px" });
    var ri = 0;
    revealEls.forEach(function (el) {
      el.classList.add("wcp-pre");
      el.style.setProperty("--wcp-d", ((ri++ % 5) * 55) + "ms");
      rio.observe(el);
    });
    // failsafe: never leave content invisible (broken IO, odd embeds, etc.)
    setTimeout(function () {
      document.querySelectorAll(".wcp-pre:not(.wcp-in)").forEach(function (el) { el.classList.add("wcp-in"); });
    }, 3000);
  }

  // ---- THE GAME HOOK: every product physically exists in the basement ----
  var pinfo = document.querySelector("main.theme-template-product .product-info");
  if (pinfo && !pinfo.querySelector(".wcp-gamelink")) {
    var gl = document.createElement("a");
    gl.href = "/pages/the-basement";
    gl.className = "wcp-gamelink";
    gl.innerHTML = "\u25c6 CATALOGED IN THE BASEMENT \u2014 this item physically exists in the 3D castle downstairs, on a shelf, in the dark. <b>retrieve it if you dare \u2192</b>";
    pinfo.appendChild(gl);
  }
})();
